import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, Clock3Icon, GiftIcon, LockKeyholeIcon, ShoppingCartIcon } from 'lucide-react';
const checkoutUrl = 'https://usa.ebookpoint.shop/cart/54923957567860:1';
export function OfferCard() {
  const [seconds, setSeconds] = useState(12 * 60 + 47);
  const remaining = 37;
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => value > 0 ? value - 1 : 12 * 60 + 47), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
  const remainingSeconds = String(seconds % 60).padStart(2, '0');
  return <section id="oferta" className="scroll-mt-4 bg-[#10243d] px-4 py-10 text-[#fff8ea]" aria-labelledby="offer-title" data-id="element-16">
      <div className="mx-auto max-w-md" data-id="element-17">
        <p className="mb-1 text-center font-heading text-sm font-bold uppercase tracking-[0.18em] text-[#f3a23a]" data-id="element-18">
          Today&apos;s Offer
        </p>
        <h2 id="offer-title" className="text-center font-heading text-3xl font-bold uppercase leading-tight" data-id="element-19">
          Protect His Arm. Improve His Game.
        </h2>

        <div className="mt-5 overflow-hidden rounded-2xl border border-[#35506e] bg-[#17314f] shadow-2xl" data-id="element-20">
          <div className="flex items-center justify-between border-b border-[#35506e] px-4 py-3" data-id="element-21">
            <div className="flex items-center gap-2 text-sm font-semibold" data-id="element-22">
              <Clock3Icon className="h-4 w-4 text-[#f3a23a]" data-id="element-23" />
              Ends in
              <time className="font-heading text-xl font-bold tracking-wider" data-id="element-24">
                {minutes}:{remainingSeconds}
              </time>
            </div>
            <span className="text-xs font-bold text-[#f3a23a]" data-id="element-25">
              {remaining}/200 spots
            </span>
          </div>

          <div className="px-4 pt-3" data-id="element-26">
            <div className="h-1.5 overflow-hidden rounded-full bg-[#0a1829]" aria-label={`${remaining} spots remaining out of 200`} data-id="element-27">
              <div className="h-full w-[18.5%] rounded-full bg-[#e56822]" data-id="element-28" />
            </div>
          </div>

          <div className="px-4 py-4" data-id="element-29">
            <div className="flex items-center gap-2" data-id="element-30">
              <GiftIcon className="h-5 w-5 shrink-0 text-[#f3a23a]" data-id="element-31" />
              <div data-id="element-32">
                <h3 className="font-heading text-lg font-bold uppercase" data-id="element-33">
                  Your complete pitcher kit
                </h3>
                <p className="text-xs text-[#ccd9e5]" data-id="element-34">
                  10 resources built for health, performance, and confidence.
                </p>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-3 overflow-hidden rounded-lg border border-[#36506d] text-center" data-id="element-35">
              <div className="border-r border-[#36506d] px-2 py-2" data-id="element-36">
                <p className="font-heading text-lg font-bold text-[#f3a23a]" data-id="element-37">
                  5
                </p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-[#ccd9e5]" data-id="element-38">
                  PDF Volumes
                </p>
              </div>
              <div className="border-r border-[#36506d] px-2 py-2" data-id="element-39">
                <p className="font-heading text-lg font-bold text-[#f3a23a]" data-id="element-40">
                  5
                </p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-[#ccd9e5]" data-id="element-41">
                  Free Bonuses
                </p>
              </div>
              <div className="px-2 py-2" data-id="element-42">
                <p className="font-heading text-lg font-bold text-[#f3a23a]" data-id="element-43">
                  200+
                </p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-[#ccd9e5]" data-id="element-44">
                  Pages
                </p>
              </div>
            </div>

            <div className="mt-3 grid gap-1.5 text-xs text-[#e2eaf0]" data-id="element-45">
              <p className="flex items-center gap-2" data-id="element-46">
                <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-[#f3a23a]" data-id="element-47" />
                Mechanics, injury prevention, strength, mindset, and workload
                management
              </p>
              <p className="flex items-center gap-2" data-id="element-48">
                <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-[#f3a23a]" data-id="element-49" />
                Calculator, roadmap, rest planner, mental reset, and progression
                tracker
              </p>
            </div>

            <div className="mt-4 flex items-end justify-between border-t border-[#35506e] pt-4" data-id="element-50">
              <div data-id="element-51">
                <p className="text-xs text-[#ccd9e5]" data-id="element-52">
                  Complete system + all bonuses
                </p>
                <p className="mt-1 text-sm text-[#ccd9e5]" data-id="element-53">
                  Regular price <s data-id="element-54">$72 USD</s>
                </p>
              </div>
              <span className="font-heading text-4xl font-bold text-[#f3a23a]" data-id="element-55">
                $25 <small className="text-base" data-id="element-56">USD</small>
              </span>
            </div>

            <a href={checkoutUrl} className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-[#e56822] px-5 py-3.5 text-center font-heading text-lg font-bold uppercase tracking-wide text-white shadow-lg transition hover:bg-[#f17b35] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#17314f]" data-id="element-57">
              <ShoppingCartIcon className="h-5 w-5" data-id="element-58" />
              Get The Complete System Today
            </a>
            <p className="mt-2.5 flex items-center justify-center gap-2 text-center text-xs text-[#ccd9e5]" data-id="element-59">
              <LockKeyholeIcon className="h-3.5 w-3.5" data-id="element-60" />
              Secure checkout · Instant digital access
            </p>
          </div>
        </div>
      </div>
    </section>;
}